<template>
    <div class="sollist-popup" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none'}" v-if="toggled">
        <div class="background" v-on:click="Close()"></div>


        <div class="picture" v-bind:style="{ background: (employee !== null ? pic : 'url(../img/default.jpg)')}" style="display:inline-block;"></div>
        <div class="label" style="text-align:center; width: 390px; display:block; line-height:60px; height:60px; margin-top:-63px;">{{ employee.firstName }} {{ employee.lastName }}</div>

        <div style="border-bottom:1px solid #ccc; width: 390px; margin-bottom:15px;"></div>


        <div v-if="weekTimeRegular > 0">
            <div style="height: 35px; overflow:hidden; width:390px; background-color:#fff; margin-bottom:15px;">



                <!-- Gray Background Bar --> <!-- Arbeitszeit laut vertrag -->
                <div style=" background-color: #d9d9d9; border-radius: 12px; height:35px;" 
                    v-bind:style="{ width: background_width+'px', border: (weekTimeRegularHover) ? 'outset 3px #bbb' : 'none'}" @mouseover="weekTimeRegularHover = true" @mouseleave="weekTimeRegularHover = false"></div>
                <div style="margin-top:-35px; height:0px;"></div>
                <div style=" margin-left:0px; height:15px; line-height: 15px; margin-top:1px; text-align: right; color:#555; font-size: 12px; padding-right: 8px;" 
                    v-bind:style="{ width: background_width+'px'}" @mouseover="weekTimeRegularHover = true" @mouseleave="weekTimeRegularHover = false">
                    {{weekTimeRegularHours}} <em><small>h</small></em>&nbsp; {{ weekTimeRegularMinutes }} <em><small>min</small></em>
                </div>
                <div style="margin-top:-16px; height:0px;"></div>
                <!-- Gray Background Bar END -->


                <!-- Monatsabschluss -->
                <div v-if="workTimeBalance_width > 0" style="border-bottom-left-radius: 8px; border-top-left-radius: 8px; background-color: #5f5f5f; margin-left:0px; height:20px; margin-top:15px; border:outset 3px #888;" 
                    v-bind:style="{width: workTimeBalance_width+'px', border: (workTimeBalanceHover) ? 'outset 3px #999' : 'none'}" @mouseover="workTimeBalanceHover = true" @mouseleave="workTimeBalanceHover = false"></div>
                <div v-if="workTimeBalance_width > 0" style="margin-top:-35px; height:0px;"></div>
                <!-- Monatsabschluss ENDE -->




                <!-- PLAN ZEITEN -->
                <div v-if="sumPlanned_with > 0" style="background-color: #a0a0a0; margin-left:0px; height:20px; margin-top:15px;" 
                    v-bind:style="{'margin-left' : sumPlanned_margin+'px' , width: sumPlanned_with+'px', border: (sumPlannedHover) ? 'outset 3px #bbb' : 'none'}" @mouseover="sumPlannedHover = true" @mouseleave="sumPlannedHover = false"></div>
                <div v-if="sumPlanned_with > 0" style="margin-top:-35px; height:0px;"></div>
        
                <div style="height:20px; line-height: 20px; margin-top:15px; text-align: center; color:#fff; font-size: 12px;" 
                    v-bind:style="{'margin-left' : sumPlanned_margin+'px' , width: sumPlanned_with+'px'}" @mouseover="sumPlannedHover = true" @mouseleave="sumPlannedHover = false">
                    <span v-show="sumPlanned_with > 75">{{sumPlannedHours}} <em><small>h</small></em>&nbsp; {{ sumPlannedMinutes }} <em><small>min</small></em></span>
                </div>
                <div style="margin-top:-35px; height:0px;"></div>
                <!-- PLAN ZEITEN ENDE -->



                <!-- GREEN UNDERTIME -->
                <div v-if="red_overtime_width <= 0 && green_overtime_width > 0" style="height:20px; margin-top:15px; border-bottom-right-radius:12px; border-top-right-radius:12px;" 
                    v-bind:style="{
                        'margin-left' : green_overtime_margin+'px' ,
                        width: green_overtime_width+'px', 
                        border: (green_overtime_hover) ? 'dashed 3px #6d8d23' : 'dashed 2px #86a14c',
                        'background-image' : green_overtime_hover ? 'linear-gradient(135deg, #86a14c 20.59%, #d9d9d9 20.59%, #d9d9d9 50%, #86a14c 50%, #86a14c 70.59%, #d9d9d9 70.59%, #d9d9d9 100%)' : '',
                        'background-size' : green_overtime_hover ? '24.04px 24.04px':'none'}" @mouseover="green_overtime_hover = true" @mouseleave="green_overtime_hover = false"></div>
                <div v-if="red_overtime_width <= 0 && green_overtime_width > 0" style="margin-top:-35px; height:0px;"></div>
                <!-- GREEN UNDERTIME ENDE -->

                <!-- RED OVERTIME -->
                <div v-if="green_overtime_width <= 0 && red_overtime_width > 0 && !sumPlannedHover" style="background-color: #e5154f; height:20px; margin-top:15px;" 
                    v-bind:style="{'margin-left' : background_width+'px' , width: red_overtime_width+'px', border: (red_overtime_hover) ? 'outset 3px #f2688f' : 'none'}" @mouseover="red_overtime_hover = true" @mouseleave="red_overtime_hover = false"></div>
                <div v-if="green_overtime_width <= 0 && red_overtime_width > 0 && !sumPlannedHover" style="margin-top:-35px; height:0px;"></div>
                <!-- RED OVERTIME ENDE -->




                <!-- FTA -->
                <div v-if="fta_width > 0 && !green_overtime_hover" style="background-color: #eeee3b; height:20px; margin-top:15px; border-bottom-right-radius:12px; border-top-right-radius:12px;" @mouseover="fta_hover = true" @mouseleave="fta_hover = false"
                    v-bind:style="{'margin-left' : fta_margin+'px' , width: fta_width+'px', border: (fta_hover) ? 'outset 3px #eeee3b' : 'none'}"></div>
                <div v-if="fta_width > 0 && !green_overtime_hover" style="margin-top:-35px; height:0px;"></div>
                <!-- FTA ENDE -->




            </div>
    

            <div style="width:390px; background-color:#fff; padding:2px; border-bottom:1px solid #dedede;" @mouseover="weekTimeRegularHover = true" @mouseleave="weekTimeRegularHover = false" v-bind:style="{'background-color': (weekTimeRegularHover) ? '#ddd' : '#fff'}">
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 14px; width: 235px;">
                    <strong>Arbeitszeit laut Vertrag</strong>
                </div>
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                    <strong>{{ weekTimeRegularHours }}</strong> &nbsp;<small>h</small>
                </div>
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                    <strong>{{ weekTimeRegularMinutes }}</strong> &nbsp;<small>min</small>
                </div>
            </div>

            <div v-if="$parent.sollIstMode == 0" style="width:390px; padding:2px;" @mouseover="workTimeBalanceHover = true" @mouseleave="workTimeBalanceHover = false" v-bind:style="{'background-color': (workTimeBalanceHover) ? '#ddd' : '#fff'}">
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 14px; width: 235px;">
                    Monatsabschluss &nbsp;<em><small>September</small></em>
                </div>
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                    {{ workTimeBalanceHours }} &nbsp;<small>h</small>
                </div>
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                    {{ workTimeBalanceMinutes }} &nbsp;<small>min</small>
                </div>
            </div>

            <div style="width:390px; background-color:#fff; padding:2px;">
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 14px; width: 235px;">
                    IST Zeiten &nbsp;<em><small v-if="$parent.sollIstMode == 0">Oktober</small></em>
                </div>
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                    0 &nbsp;<small>h</small>
                </div>
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                    0 &nbsp;<small>min</small>
                </div>
            </div>

            <div style="width:390px; background-color:#fff; padding:2px;" @mouseover="sumHolidayHover = true" @mouseleave="sumHolidayHover = false" v-bind:style="{'background-color': (sumHolidayHover) ? '#ddd' : '#fff'}">
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 14px; width: 235px;">
                    Urlaub &nbsp;<em><small v-if="$parent.sollIstMode == 0">Oktober</small></em>
                </div>
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                    {{ sumHolidayHours }} &nbsp;<small>h</small>
                </div>
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                    {{ sumHolidayMinutes}} &nbsp;<small>min</small>
                </div>
            </div>

            <div style="width:390px; background-color:#fff; padding:2px;" @mouseover="sumSickHover = true" @mouseleave="sumSickHover = false" v-bind:style="{'background-color': (sumSickHover) ? '#ddd' : '#fff'}">
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 14px; width: 235px;">
                    Krankenstand &nbsp;<em><small v-if="$parent.sollIstMode == 0">Oktober</small></em>
                </div>
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                    {{ sumSickHours }} &nbsp;<small>h</small>
                </div>
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                    {{ sumSickMinutes}} &nbsp;<small>min</small>
                </div>
            </div>

            <div style="width:390px; background-color:#fff; padding:2px;" @mouseover="sumPlannedHover = true" @mouseleave="sumPlannedHover = false" v-bind:style="{'background-color': (sumPlannedHover) ? '#ddd' : '#fff'}">
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 14px; width: 235px;">
                    Plan Zeiten &nbsp;<em><small v-if="$parent.sollIstMode == 0">Oktober</small></em>
                </div>
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                    {{ sumPlannedHours }} &nbsp;<small>h</small>
                </div>
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                    {{ sumPlannedMinutes}} &nbsp;<small>min</small>
                </div>
            </div>

            
            <div style="width:390px; background-color:#fff; padding:2px; border-bottom:1px solid #dedede;">
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 14px; width: 235px;">
                    <strong>Dienstplan Summe</strong> &nbsp;<em><small v-if="$parent.sollIstMode == 0">Oktober</small></em>
                </div>
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                    <strong>{{ summHours }}</strong> &nbsp;<small>h</small>
                </div>
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                    <strong>{{ summMinutes}}</strong> &nbsp;<small>min</small>
                </div>
            </div>

            <div style="width:390px; background-color:#fff; padding:2px; border-bottom:3px double #dedede;" 
            v-bind:style="{ color: (diff <= 0 ? '#6d8d23' : '#e5154f'),'background-color': (red_overtime_hover) ? '#ffe3e3' : (green_overtime_hover) ? '#dfebd3' : '#fff'}" 
            @mouseover="diff<= 0 ? green_overtime_hover = true : red_overtime_hover = true" @mouseleave="diff<= 0 ? green_overtime_hover = false : red_overtime_hover = false">
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 14px; width: 235px;">
                    <strong>Abweichung</strong>
                </div>
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                    <strong>{{ diffHours }}</strong> &nbsp;<small>h</small>
                </div>
                <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                    <strong>{{ diffMinutes}}</strong> &nbsp;<small>min</small>
                </div>
            </div>





            <div v-bind:style="{ color: (diff <= 0 ? '#000' : '#afafaf')}">
                <div style="width:390px; background-color:#fff; padding:2px; border-bottom:1px solid #dedede; margin-top: 40px;">
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 14px; width: 235px;">
                        <strong>Feiertags Stunden Übersicht</strong>
                    </div>
                </div>

                <div v-if="$parent.sollIstMode == 0" style="width:390px; background-color:#fff; padding:2px;">
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 14px; width: 235px;">
                        Monatsabschluss &nbsp;<em><small>September</small></em>
                    </div>
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                        {{ holidayTimeBalanceHours }} &nbsp;<small>h</small>
                    </div>
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                        {{ holidayTimeBalanceMinutes }} &nbsp;<small>min</small>
                    </div>
                </div>

                <div style="width:390px; background-color:#fff; padding:2px;">
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 14px; width: 235px;">
                        IST Feiertagsstunden &nbsp;<em><small v-if="$parent.sollIstMode == 0">Oktober</small></em>
                    </div>
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                        0 &nbsp;<small>h</small>
                    </div>
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                        0 &nbsp;<small>min</small>
                    </div>
                </div>

                <div style="width:390px; background-color:#fff; padding:2px;">
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 14px; width: 235px;">
                        Plan Feiertagsstunden &nbsp;<em><small v-if="$parent.sollIstMode == 0">Oktober</small></em>
                    </div>
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                        {{ sumPlannedFTAHours }} &nbsp;<small>h</small>
                    </div>
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                        {{ sumPlannedFTAMinutes }} &nbsp;<small>min</small>
                    </div>
                </div>

                <div style="width:390px; background-color:#fff; padding:2px;">
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 14px; width: 235px;">
                        Geplanter Ausgleich &nbsp;<em><small v-if="$parent.sollIstMode == 0">Oktober</small></em>
                    </div>
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                        0 &nbsp;<small>h</small>
                    </div>
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                        0 &nbsp;<small>min</small>
                    </div>
                </div>

                
                <div style="width:390px; background-color:#fff; padding:2px; border-bottom:1px solid #dedede;">
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 14px; width: 235px;">
                        <strong>Feiertagsstunden Summe</strong> &nbsp;<em><small v-if="$parent.sollIstMode == 0">Oktober</small></em>
                    </div>
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                        <strong>{{ holidayTimeBalanceHours }}</strong> &nbsp;<small>h</small>
                    </div>
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                        <strong>{{ holidayTimeBalanceMinutes}}</strong> &nbsp;<small>min</small>
                    </div>
                </div>

                <div style="width:390px; background-color:#fff; padding:2px; border-bottom:3px double #dedede;" @mouseover="fta_hover = true" @mouseleave="fta_hover = false" v-bind:style="{'background-color': (fta_hover) ? '#ffffa6' : '#fff'}">
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 14px; width: 235px;">
                        <strong>Abweichung</strong>
                    </div>
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                        <strong>{{ holidayTimeBalanceHours }}</strong> &nbsp;<small>h</small>
                    </div>
                    <div style="display:inline-block; height: 15px; line-height:15px; font-size: 13px; width: 70px; text-align:right;">
                        <strong>{{ holidayTimeBalanceMinutes}}</strong> &nbsp;<small>min</small>
                    </div>
                </div>
            </div>







        </div>
        <div v-if="weekTimeRegular <= 0" style="width:100%; text-align:center;color: #e5154f;">
            <strong>Kein Arbeitsvertrag</strong>
        </div>



    </div>
</template>
<script>
    export default {
        name: 'sollistpopup',
        components: {
        },
        data(){
            return{
                employee: null,
                pic: '',
                toggled: false,
                elRelative: null,
                posx: 0,
                posy: 0,
                oneMinuteInPixel: 0,
                background_width: 390,

                weekTimeRegular: 0.0,
                weekTimeRegularHours: 0.0,
                weekTimeRegularMinutes: 0.0,
                weekTimeRegularHover: false,

                monthBalanceFound: false,
                vacationTimeBalance: 0,

                workTimeBalance: 0,
                workTimeBalanceHours: 0,
                workTimeBalanceMinutes: 0,
                workTimeBalanceHover: false,
                workTimeBalance_width: 0,

                sumPlanned: 0,
                sumPlannedHours: 0,
                sumPlannedMinutes: 0,
                sumPlannedHover: false,
                sumPlanned_margin: 0,
                sumPlanned_with: 0,
                
                sumHoliday: 0,
                sumHolidayHours: 0,
                sumHolidayMinutes: 0,
                sumHolidayHover: false,
                sumHoliday_margin: 0,
                sumHoliday_with: 0,

                sumSick: 0,
                sumSickHours: 0,
                sumSickMinutes: 0,
                sumSickHover: false,
                sumSick_margin: 0,
                sumSick_with: 0,
                
                sumPlannedFTA: 0,
                sumPlannedFTAHours: 0,
                sumPlannedFTAMinutes: 0,
                sumPlannedFTAHover: false,
                sumPlannedFTA_margin: 0,
                sumPlannedFTA_with: 0,

                diff: 0,
                diffHours: 0,
                diffMinutes: 0,

                red_overtime_width: 0,
                red_overtime_hover: false,
                green_overtime_margin: 0,
                green_overtime_width: 0,
                green_overtime_hover: false,
                

                
                holidayTimeBalance: 0,
                holidayTimeBalanceHours: 0,
                holidayTimeBalanceMinutes: 0,

                fta_margin: 0,
                fta_width: 0,
                fta_hover: false,
            }
        },
        created () {
            var view = this;
        },
        destroyed(){
        },
        methods: {
            Close(){
                if($(window.mouse.element).closest('.sollist-popup').length > 0) return;
                this.Toggle(false);
            },
            Toggle(val){
                if(val !== undefined || val !== null) {
                    this.toggled = val;
                    return;
                }
                this.toggled = !this.toggled;
            },



            Init(parent, employee, elRelative){
                this.employee = employee;
                this.pic = this.GetProfilePictureUrl(employee);
                this.toggled = true;


                this.weekTimeRegular = employee.si_weekTimeRegular;
                let overflow = (employee.si_overflow > 1) ? 1 : employee.si_overflow;
                this.oneMinuteInPixel = 390 / this.weekTimeRegular * overflow;// Calculate one Minute in Pixels
                this.background_width = 390 * overflow;


                this.weekTimeRegularHours = Math.floor(this.weekTimeRegular / 60.0);
                this.weekTimeRegularMinutes = Math.floor(this.weekTimeRegular - this.weekTimeRegularHours * 60);

                this.monthBalanceFound = employee.si_monthBalanceFound;
                this.vacationTimeBalance = Math.round(employee.si_vacationTimeBalance * 100.0) / 100;

                this.workTimeBalance = employee.si_workTimeBalance;
                this.workTimeBalanceHours = Math.floor(this.workTimeBalance / 60.0);
                this.workTimeBalanceMinutes = Math.floor(this.workTimeBalance - this.workTimeBalanceHours * 60);
                this.workTimeBalance_width = this.workTimeBalance * this.oneMinuteInPixel;




                this.sumPlanned = employee.si_sumPlanned;
                this.sumPlannedHours = Math.floor(this.sumPlanned / 60.0);
                this.sumPlannedMinutes = Math.floor(this.sumPlanned - this.sumPlannedHours * 60);
                this.sumPlanned_margin = this.workTimeBalance_width; // + ist time
                this.sumPlanned_with = employee.si_sumPlanned * this.oneMinuteInPixel;



                this.sumHoliday = employee.si_sumHoliday;
                this.sumHolidayHours = Math.floor(this.sumHoliday / 60.0);
                this.sumHolidayMinutes = Math.floor(this.sumHoliday - this.sumHolidayHours * 60);
                this.sumHoliday_margin = this.workTimeBalance_width; // + ist time
                this.sumHoliday_with = employee.si_sumHoliday * this.oneMinuteInPixel;

                this.sumSick = employee.si_sumSickness;
                this.sumSickHours = Math.floor(this.sumSick / 60.0);
                this.sumSickMinutes = Math.floor(this.sumSick - this.sumSickHours * 60);
                this.sumSick_margin = this.workTimeBalance_width; // + ist time
                this.sumSick_with = employee.si_sumSickness * this.oneMinuteInPixel;



                this.summ = this.workTimeBalance + this.sumPlanned; // + IST ZEITEN
                this.summHours = Math.floor(this.summ / 60.0);
                this.summMinutes = Math.floor(this.summ - this.summHours * 60);



                this.diff = this.summ - this.weekTimeRegular;
                this.diffHours = Math.floor(this.diff / 60.0);
                this.diffMinutes = Math.floor(this.diff - this.diffHours * 60);

                this.red_overtime_width = 0;
                if(this.diff > 0){
                    this.red_overtime_width = this.diff * this.oneMinuteInPixel;
                    this.green_overtime_margin = 0;
                    this.green_overtime_width = 0;
                }else{
                    this.red_overtime_width = 0;
                    this.green_overtime_margin = this.sumPlanned_margin + this.sumPlanned_with;
                    this.green_overtime_width = (this.diff*(-1)) * this.oneMinuteInPixel;
                }




                this.holidayTimeBalance = employee.si_holidayTimeBalance;
                this.holidayTimeBalanceHours = Math.floor(this.holidayTimeBalance / 60.0);
                this.holidayTimeBalanceMinutes = Math.floor(this.holidayTimeBalance - this.holidayTimeBalanceHours * 60);





                this.sumPlannedFTA = employee.si_sumHolidayPlanned;
                this.sumPlannedFTAHours = Math.floor(this.sumPlannedFTA / 60.0);
                this.sumPlannedFTAMinutes = Math.floor(this.sumPlannedFTA - this.sumPlannedFTAHours * 60);
                this.sumPlannedFTA_margin = this.workTimeBalance_width; // + ist time
                this.sumPlannedFTA_with = employee.sumHolidayPlanned * this.oneMinuteInPixel;




                this.fta_margin = this.sumPlanned_margin + this.sumPlanned_with;
                this.fta_width = (this.holidayTimeBalance + this.sumPlannedFTA) * this.oneMinuteInPixel;


                if(elRelative){
                    this.elRelative = elRelative
                    this.Reposition();
                }
            },










            GetProfilePictureUrl(employee){
                if(!employee || !employee.employeePicture || !employee.employeePicture.server) return '#ccc no-repeat center/cover  url(../img/default.jpg)';
                var d = new Date();
                return '#ccc no-repeat center/cover  url(' + employee.employeePicture.server + '/api/file?id='+ employee.employeePicture.fileId +'&accessToken='+employee.employeePicture.accessToken +"&thumb=small"+ '&time='+Date.now()+')';
            },
            Reposition(){
                var view = this;
                requestAnimationFrame(function(){
                    if(!view.elRelative) return;
                    var box = view.elRelative.getBoundingClientRect();
                    view.posx = box.left + box.width + 10;
                    view.posy = box.top - 20;

                    var userselectheight = 520;
                    var heightTotal = window.innerHeight;
                    if(heightTotal - box.top < userselectheight) {
                        view.posy = box.top - (userselectheight - (heightTotal - box.top)) - 50;
                    } else {
                        if(heightTotal < userselectheight) {
                            view.posy = 5;
                        } else {
                            view.posy = box.top - 20;
                        }
                    }
                    view.$forceUpdate();
                });
            },

        },
        mounted() {
            $('html').append(this.$el);
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



    .sollist-popup{
        position:fixed;
        display:inline-block;
        max-height: 620px;
        width: 450px;
        border-radius: 5px;
        display:none;
        z-index: 1000;
        background: white;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        padding: 30px;
        border: 1px solid #a5a5a5;

        top: 120px;
        left: 40px;
    }

     .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }


    .picture{
        background-size: 100%;
        height: 60px;
        width: 60px;
        border-radius: 100px;
        box-shadow: inset 0 -1px 0 0px #888;
        display:inline-block;
    }
    .label{
        padding-left: 60px;
        font-size: 24px;
        color: #6d8d23;
        font-family: DistrictProBook;
        font-weight: 700;
        margin-bottom: 5px;
    }





    .fa-stack.cancel{
        cursor: pointer;
        position: absolute;
        top: 6px;
        right: 5px;
        font-size: 10px;
        transform: scale(.8);
    }
    .fa-stack.cancel .fa-circle{
    }
    .fa-stack.cancel .fa-times{
        font-size: 13px;
        transform: translateY(3px);
    }


</style>
